import React__default from 'react';

function DummyInput({ innerRef, ...props }) {
    return (React__default.createElement("input", { ref: innerRef, ...props, tabIndex: -1, inputMode: "none", style: {
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'absolute',
            transform: 'scale(.01)',
            zIndex: -1,
        } }));
}

export { DummyInput };
//# sourceMappingURL=DummyInput.js.map
